import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

export const LoginPage: React.FC = () => {
  const oktaAuthContext = useOktaAuth();
  const oktaAuth = oktaAuthContext?.oktaAuth;
  const authState = oktaAuthContext?.authState;

  const handleLogin = async () => {
    if (!oktaAuth) return;
    await oktaAuth.signInWithRedirect();
  };

  if (!authState) {
    return <div>Loading...</div>;
  }

  if (authState.isAuthenticated) {
    return <div>Already logged in</div>;
  }

  return (
    <div className="min-h-screen flex">
      {/* Left side - Branded Background */}
      <div className="hidden lg:block w-1/2 relative overflow-hidden bg-gradient-to-br from-blue-700 via-blue-800 to-blue-900">
        {/* Animated gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/30 via-transparent to-purple-600/20"></div>

        {/* Decorative circles - WPP dot pattern inspired */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-32 h-32 rounded-full bg-white blur-xl"></div>
          <div className="absolute top-40 right-32 w-24 h-24 rounded-full bg-white blur-lg"></div>
          <div className="absolute bottom-32 left-40 w-40 h-40 rounded-full bg-white blur-2xl"></div>
          <div className="absolute bottom-20 right-20 w-28 h-28 rounded-full bg-white blur-xl"></div>
        </div>

        {/* Content overlay */}
        <div className="absolute inset-0 flex flex-col items-center justify-center p-12 text-white">
          <div className="max-w-md space-y-6 text-center">
            <h1 className="text-4xl font-light tracking-wide">
              <span className="font-semibold">VML MAP</span> Agent Apps
            </h1>
            <p className="text-lg text-blue-100 font-light leading-relaxed">
              AI-powered content management and governance tools
            </p>
            <div className="pt-4 space-y-2 text-sm text-blue-200">
              <div className="flex items-center justify-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-300"></div>
                <span>Content Tracker</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-300"></div>
                <span>Content QC</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-white p-8">
        <div className="max-w-md w-full text-center space-y-12">
          {/* Logo */}
          <div className="flex justify-center">
            <img src="/wpp-open-logo.png" alt="WPP Open" className="h-16 w-auto object-contain" />
          </div>

          <div className="space-y-8">
            <div className="space-y-2">
              <h2 className="text-3xl font-light text-blue-900">Sign in</h2>
              <p className="text-sm text-gray-500">Access VML MAP Agent Apps</p>
            </div>

            <button
              onClick={handleLogin}
              style={{
                backgroundColor: '#1e3a8a',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                padding: '16px 24px',
                borderRadius: '8px',
                fontWeight: '500',
                width: '100%',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1e40af';
                e.currentTarget.style.transform = 'scale(1.02)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#1e3a8a';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                  fill="currentColor"
                />
                <path
                  d="M12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16Z"
                  fill="currentColor"
                />
              </svg>
              Sign in with WPP Okta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
